var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 17 23",
    style: {
      enableBackground: "new 0 0 17 23"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:$primary-color;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.5,2c1.7,0,3,1.3,3,3s-1.3,3-3,3s-3-1.3-3-3S6.8,2,8.5,2 M8.5,14c2,0,3.6,0.8,4.5,2.2c0,0,0,0,0,0 c0.8,1.1,1.3,2.7,1.4,4.7H2.5c0.1-2,0.6-3.6,1.4-4.8C4.9,14.8,6.5,14,8.5,14 M8.5,0c-2.8,0-5,2.2-5,5s2.2,5,5,5s5-2.2,5-5 S11.3,0,8.5,0L8.5,0z M8.5,12c-2.8,0-4.9,1.2-6.2,3.1S0.5,19.4,0.5,22c0,0.6,0.4,1,1,1h14c0.6,0,1-0.4,1-1c0-2.6-0.5-5.1-1.8-6.9 C13.4,13.2,11.3,12,8.5,12L8.5,12z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.9c5445a681dbcb31696bd866a19bef33.svg";
export { ForwardRef as ReactComponent };